// some
export const PAGE_SIZE = 10;

// master
export const GET_CITY = "GET_CITY";
export const GET_COUNTRY = "GET_COUNTRY";
export const GET_COMMISSION = "GET_COMMISSION";

// expert
export const GET_EXPERT = "GET_EXPERT";
export const GET_EXPERT_BY_ID = "GET_EXPERT_BY_ID";

// company
export const GET_WALLET = "GET_WALLET";
export const GET_WALLET_GRAPH = "GET_WALLET_GRAPH";
export const GET_DEBITED = "GET_DEBITED";

// company
export const GET_COMPANY = "GET_COMPANY";
export const GET_COMPANY_BY_ID = "GET_COMPANY_BY_ID";

// GET_CALENDER
export const GET_CALENDER = "GET_CALENDER";
export const GET_CALENDER_BY_ID = "GET_CALENDER_BY_ID";


// category
export const GET_CATEGARY = "GET_CATEGARY";
export const GET_LANGUAGE = "GET_LANGUAGE";
export const GET_SKILLS = "GET_SKILLS";
export const GET_SKILLS_WITH_CATEGORY = "GET_SKILLS_WITH_CATEGORY";
export const GET_INDUSTRY = "GET_INDUSTRY";
export const GET_DEGREE = "GET_DEGREE";
export const GET_PROFICIENCY = "GET_PROFICIENCY";
export const GET_SUBCATEGARY = "GET_SUBCATEGARY";
export const GET_DELIVERY_TYPE = "GET_DELIVERY_TYPE";
export const GET_PENALTY = "GET_PENALTY";
export const GET_PRIORITY = "GET_PRIORITY";
export const GET_RATING = "GET_RATING";

// JobPosts
export const GET_POSTS = "GET_POSTS";
export const GET_UMBRELLA_POSTS = "GET_UMBRELLA_POSTS";
export const GET_MINE_UMBRELLA_POSTS = "GET_MINE_UMBRELLA_POSTS";
export const GET_UMBRELLA_POSTS_LIST_BY_ID = "GET_UMBRELLA_POSTS_LIST_BY_ID";
export const GET_UMBRELLA_POSTS_BY_ID = "GET_UMBRELLA_POSTS_BY_ID";
export const GET_FILTER_POSTS = "GET_FILTER_POSTS";
export const GET_SIMILAR_POSTS = "GET_SIMILAR_POSTS";
export const GET_MINE_POSTS = "GET_MINE_POSTS";
export const GET_POSTS_COUNT = "GET_POSTS_COUNT";
export const GET_COMPLETD_MINE_POSTS = "GET_COMPLETD_MINE_POSTS";
export const GET_COMPLETD_MINE_UMB_POSTS = "GET_COMPLETD_MINE_UMB_POSTS";
export const GET_POSTS_BY_ID = "GET_POSTS_BY_ID";
export const GET_FILTERD_POSTS = "GET_FILTERD_POSTS";
export const GET_PROPOSED_POST = "GET_PROPOSED_POST";
export const GET_ACTIVE_POST = "GET_ACTIVE_POST";
export const GET_DEACTIVE_POST = "GET_DEACTIVE_POST";
// GET_FILTER
export const GET_FILTER = "GET_FILTER";

// GET_FILTER
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const GET_NOTIFICATION_COUNT = "GET_NOTIFICATION_COUNT";
export const GET_INVITATION = "GET_INVITATION";
export const GET_JOIN = "GET_JOIN";
export const GET_CHAT_USER = "GET_CHAT_USER";
export const GET_ALL_CHATS = "GET_ALL_CHATS";
export const GET_SEARCH_CHATS_USER = "GET_SEARCH_CHATS_USER";
export const GET_POST_TYPE_CHATS = "GET_POST_TYPE_CHATS";

// GET_PROFILE
export const GET_PROFILE = "GET_PROFILE";
export const GET_CONTRACT = "GET_CONTRACT";
export const GET_DASHBOARD = "GET_DASHBOARD";
export const GET_REPORT_OVERVIEW = "GET_REPORT_OVERVIEW";
export const GET_OVERVIEW_BUSINESS_GRAPH = "GET_OVERVIEW_BUSINESS_GRAPH";
export const GET_REPORT_BUSINESS = "GET_REPORT_BUSINESS";
export const GET_REPORT_BUSINESS_GRAPH = "GET_REPORT_BUSINESS_GRAPH";
export const GET_PORTPOLIO = "GET_PORTPOLIO";
export const GET_PORTPOLIO_BY_ID = "GET_PORTPOLIO_BY_ID";

// GET_PROFILE
export const GET_MEMBERSHIP = "GET_MEMBERSHIP";
export const GET_MEMBERSHIP_BY_ID = "GET_MEMBERSHIP_BY_ID";
export const GET_MY_MEMBERSHIP_DETAILS = "GET_MY_MEMBERSHIP_DETAILS";

// GET_PROJECT
export const GET_PROJECT = "GET_PROJECT";
export const GET_MYOREDR_PROJECT = "GET_MYOREDR_PROJECT";
export const GET_UMBERALLY_PROJECT = "GET_UMBERALLY_PROJECT";
export const GET_ACTIVE_PROJECT = "GET_ACTIVE_PROJECT";
export const GET_COMPLETE_PROJECT = "GET_COMPLETE_PROJECT";
export const GET_APPLIED_PROJECT = "GET_APPLIED_PROJECT";
export const GET_PROJECT_BY_ID = "GET_PROJECT_BY_ID";
export const GET_PROJECT_PROPOSAL_BY_ID = "GET_PROJECT_PROPOSAL_BY_ID";

// GET_MYOREDR_UMBRELLA
export const GET_MYOREDR_UMBRELLA_PROJECT = "GET_MYOREDR_UMBRELLA_PROJECT";

// GET_CONTEST
export const GET_CONTEST = "GET_CONTEST";
export const GET_CONTEST_PROPOSAL_BY_ID = "GET_CONTEST_PROPOSAL_BY_ID";
export const GET_CONTEST_PUBLIC_COMMENT = "GET_CONTEST_PUBLIC_COMMENT";
export const GET_CONTEST_CHILD_PUBLIC_COMMENT =
  "GET_CONTEST_CHILD_PUBLIC_COMMENT";
export const GET_CONTEST_MODEL_COMMENT = "GET_CONTEST_MODEL_COMMENT";
export const GET_MYOREDR_CONTEST = "GET_MYOREDR_CONTEST";
export const GET_PROPOSED_CONTEST = "GET_PROPOSED_CONTEST";
export const GET_ACTIVE_CONTEST = "GET_ACTIVE_CONTEST";
export const GET_COMPLETE_CONTEST = "GET_COMPLETE_CONTEST";
export const GET_CONTEST_ENTRY_LIST = "GET_CONTEST_ENTRY_LIST";
export const GET_CONTEST_COMMENT_LIST = "GET_CONTEST_COMMENT_LIST";
export const GET_CONTEST_BY_ID = "GET_CONTEST_BY_ID";

// GET_JOB
export const GET_JOB = "GET_JOB";
export const GET_MYOREDR_JOB = "GET_MYOREDR_JOB";
export const GET_APPLIED_JOB = "GET_APPLIED_JOB";
export const GET_ACTIVE_JOB = "GET_ACTIVE_JOB";
export const GET_COMPLETE_JOB = "GET_COMPLETE_JOB";
export const GET_JOB_BY_ID = "GET_JOB_BY_ID";
export const GET_PROPOSED_JOB = "GET_PROPOSED_JOB";

// GET_TEAM
export const GET_TEAM_PROJECT = "GET_TEAM_PROJECT";
export const GET_TEAM_MILESTONE = "GET_TEAM_MILESTONE";
export const GET_TEAM_TASK = "GET_TEAM_TASK";
export const GET_TEAM_OVERVIEW = "GET_TEAM_OVERVIEW";
export const GET_TEAM_MEMBER = "GET_TEAM_MEMBER";
export const GET_TEAM_FILE_FOLDER = "GET_TEAM_FILE_FOLDER";
export const GET_TEAM_FILE_BYID = "GET_TEAM_FILE_BYID";
export const GET_TEAM_SEARCH_EXPERT = "GET_TEAM_SEARCH_EXPERT";
export const GET_COMPANY_SEARCH_EXPERT = "GET_COMPANY_SEARCH_EXPERT";

// GET_HIRE
export const GET_USER_FOR_HIRE = "GET_USER_FOR_HIRE";
export const GET_FILTERD_HIRE_EXPERT = "GET_FILTERD_HIRE_EXPERT";
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const GET_FOLLOW_PROFILE = "GET_FOLLOW_PROFILE";
export const GET_INDUSTRY_CATEGORY_FOR_HIRE = "GET_INDUSTRY_CATEGORY_FOR_HIRE";
export const GET_CATEGORY_BY_ID_FOR_HIRE = "GET_CATEGORY_BY_ID_FOR_HIRE";

// GET_OTS
export const GET_OTS = "GET_OTS";
export const GET_FILTERD_OTS = "GET_FILTERD_OTS";
export const GET_BXP_OTS_MINE = "GET_BXP_OTS_MINE";
export const GET_PROJECT_OTS_MINE = "GET_PROJECT_OTS_MINE";
export const GET_BXP_OTS_BY_ID = "GET_BXP_OTS_BY_ID";
export const GET_MINE_BXP_ORDER = "GET_MINE_BXP_ORDER";
export const GET_BXP_ORDER = "GET_BXP_ORDER";
export const GET_BXP_THOGETHER1 = "GET_BXP_THOGETHER1";
export const GET_BXP_THOGETHER2 = "GET_BXP_THOGETHER2";
export const GET_OTS_REQUEST_BY_ID = "GET_OTS_REQUEST_BY_ID";
export const GET_BXP_THOGETHER3 = "GET_BXP_THOGETHER3";
export const GET_BXP_THOGETHER4 = "GET_BXP_THOGETHER4";
export const GET_BXP_THOGETHER5 = "GET_BXP_THOGETHER5";
export const GET_MINE_ACTIVE_BXP_LIST = "GET_MINE_ACTIVE_BXP_LIST";

// GET_AUCTION
export const GET_AUCTION = "GET_AUCTION";
export const GET_FILTERD_AUCTION = "GET_FILTERD_AUCTION";
export const GET_AUCTION_MINE = "GET_AUCTION_MINE";
export const GET_AUCTION_BY_ID = "GET_AUCTION_BY_ID";
export const GET_MINE_AUCTION_ORDER_DETAILS = "GET_MINE_AUCTION_ORDER_DETAILS";
export const GET_MINE_ACTIVE_AUCTION_ORDER_DETAILS = "GET_MINE_ACTIVE_AUCTION_ORDER_DETAILS";
export const GET_AUCTION_ORDER_DETAILS = "GET_AUCTION_ORDER_DETAILS";

// GET_RENTAL
export const GET_RENTAL = "GET_RENTAL";
export const GET_MINE_RENTAL_ORDER = "GET_MINE_RENTAL_ORDER";
export const GET_RENTAL_ORDER = "GET_RENTAL_ORDER";
export const GET_RENTAL_REQUEST_BY_ID = "GET_RENTAL_REQUEST_BY_ID";
export const GET_FILTERD_RENTAL = "GET_FILTERD_RENTAL";
export const GET_RENTAL_MINE = "GET_RENTAL_MINE";
export const GET_RENTAL_BY_ID = "GET_RENTAL_BY_ID";

// GET_MERGER
export const GET_MERGER = "GET_MERGER";
export const GET_FILTERD_MERGER = "GET_FILTERD_MERGER";
export const GET_MERGER_MINE = "GET_MERGER_MINE";
export const GET_MERGER_BY_ID = "GET_MERGER_BY_ID";
export const GET_MINE_MERGERS_ORDER_DETAILS = "GET_MINE_MERGERS_ORDER_DETAILS";
export const GET_MERGERS_ORDER_DETAILS = "GET_MERGERS_ORDER_DETAILS";


// GET_BUY
export const GET_BUY = "GET_BUY";
export const GET_BUY_MINE = "GET_BUY_MINE";
export const GET_BUY_BY_ID = "GET_BUY_BY_ID";

// GET_SALE
export const GET_SALE = "GET_SALE";
export const GET_FILTERD_SALE = "GET_FILTERD_SALE";
export const GET_SALE_MINE = "GET_SALE_MINE";
export const GET_SALE_BY_ID = "GET_SALE_BY_ID";
export const GET_SALE_REQUEST_BY_ID = "GET_SALE_REQUEST_BY_ID";
export const GET_MINE_SALE_ORDER_DETAILS = "GET_MINE_SALE_ORDER_DETAILS";
export const GET_SALE_ORDER_DETAILS = "GET_SALE_ORDER_DETAILS";

// GET_CV
export const GET_CV = "GET_CV";
export const GET_CV_MINE = "GET_CV_MINE";
export const GET_CV_BY_ID = "GET_CV_BY_ID";
export const GET_CATEGORY_CANDIDATE_CV = "GET_CATEGORY_CANDIDATE_CV";
export const GET_ALREADY_DOWNLOADED_CV_LIST = "GET_ALREADY_DOWNLOADED_CV_LIST";
export const GET_FILTER_CV = "GET_FILTER_CV";
export const GET_CV_DETAILS_BY_ID = "GET_CV_DETAILS_BY_ID";
export const GET_FILTERD_CV = "GET_FILTERD_CV";

// Settings:
export const GET_SETTINGS = "GET_SETTINGS";
export const GET_PAYMENT_TRANSACTION_DETAILS = "GET_PAYMENT_TRANSACTION_DETAILS";
export const GET_PAYMENT_TYPE = "GET_PAYMENT_TYPE";
